(function($, undefined) {
	
	'use strict';
	var XMLUtils;
	var lexiqueUtils;
	var multiUploadImageAdmin;
	var removeMultiUploadAdminImageBtn;
	
	var tellStoryTextarea;
	
	var singleImageAdminComponent;
	
	var textsSelectorAdmin;
	var textSelectorItem;
	var textSelectorAdminForm;
	
	var addLexiqueWordFormCtn;
	
	var adminSaveExerciseInfoBtn;
	
	var baseExerciseXML;
	
	/**
	 * Multi images admin
	 */
	var updateUploadImageAdminVisibility = function() {
		var imageCtn = $(this);
		var img = $('.image', imageCtn);
		
		if (img.attr('src').length > 0) {
			imageCtn.removeClass('hide');
		}
		else {
			imageCtn.addClass('hide');
		}
	};
	
	var removeMultiUploadAdminImage = function() {
		var t = $(this);
		var ctn = t.closest('.image-ctn');
		var img = $('.image', ctn);
		
		img.attr('src', '');
		ctn.trigger('file-picker-change');
	};
	
	var createMultiImagesString = function(container) {
		var string = "";
		var hasGoodAnswer;
		$('.multi-images-ctn', container).find('.multi-images-item-ctn').each(function(i, el) {
			var item = $(el);
			if (item.find('.image').attr('src')) {
				hasGoodAnswer = item.find('.good-answer-selector-ctn').length > 0;
				
				if (string.length > 0) { 
					string += ','; 
				}
				string += item.find('.image').attr('src');
				if (hasGoodAnswer) {
					var isGoodAnswer = item.find('[name=good-answer]').is(':checked');
					string += '|*|' + isGoodAnswer;
				}
			}
		});
		return string;
	};
	
	var buildMultiImagesXml = function(imagesList, step) {
		var baseXMLClone = baseExerciseXML.cloneNode(true);
		var imagesXmlString = '<Images list="' + imagesList + '"/>';
		var stepNode = createStepNode(step, imagesXmlString);
		baseXMLClone.documentElement.appendChild(stepNode.documentElement);
		return baseXMLClone;
	};
	
	var createStepNode = function(index, childrenXMLString) {
		return XMLUtils.stringToXML('<Step index="' + index + '">' + childrenXMLString + '</Step>');
	};
	
	
	/**
	 * Tell story section (text || record)
	 */
	var hideTellStoryTextareaOverText = function() {
		var t = $(this);
		t.closest('.textarea-ctn').find('.over-textarea-text').addClass('hide');
	};
	var showTellStoryTextareaOverTextIfEmpty = function() {
		var t = $(this);
		if (t.val().length === 0) {
			t.closest('.textarea-ctn').find('.over-textarea-text').removeClass('hide');
		}
	};


	/**
	 * Single image admin
	 */
	var updateSingleImageAdminVisibility = function() {
		var img = $(this);
		var imageCtn = img.closest('.image-ctn');
		
		if (img.attr('src').length > 0) {
			imageCtn.removeClass('hide');
		}
		else {
			imageCtn.addClass('hide');
		}
	};
	
	var removeSingleImageAdminImage = function() {
		var t = $(this);
		var ctn = t.closest('.image-ctn');
		var img = $('.image', ctn);	
		
		img.attr('src', '');
		img.trigger('file-picker-change');
	};
	
	
	/**
	 * Texts selector admin
	 */
	var onSubmitTextSelectorForm = function() {
		var isEditing = textSelectorAdminForm.find('[name=id]').val().length > 0;
		var btn = $(this);
		var ctn = btn.closest('.text-input-ctn');
		
		var editorId = $('textarea', ctn).attr('id');
		var itemCount = btn.closest('.texts-selector-admin').find('.text-selector-item').length;
		
		if ((itemCount < 6 && !isEditing) || isEditing) {
			var gendataId = $('.extraDataData').attr('data-id');
			var index = isEditing ? textSelectorAdminForm.find('[name=index]').val() : itemCount + 1;
			var isGoodAnswer = isEditing ? textSelectorAdminForm.find('[name=isGoodAnswer]').val() : false;
			var text = tinymce.get(editorId).getContent();
			
			if (isEditing) {
				var item = $('.text-selector-item').filter('[data-index=' + index + ']');
				item.find('.text-ctn').html(text);
			} else {
				var template = $('.text-selector-item.template').clone(true);
				template.find('.text-ctn').html(text);
				template.attr('data-index', index);
				template.removeClass('template');
				$('.texts-selector-admin .texts-ctn').append(template);
			}
			
			tinymce.get(editorId).setContent("");
			textSelectorAdminForm.find('[name=id]').val("");
			textSelectorAdminForm.find('[name=index]').val("");
			textSelectorAdminForm.find('[name=isGoodAnswer]').val("");
		}
	};
	
	var saveGenData = function(id, extraData, callback = () => {}) {
		var params = {
			ajax: true,
			extraData: extraData
		};
		if (id) { params.id = id; }
		
		$.ajax({
			url: '/action/manageGenData',
			method: 'post',
			data: params,
			complete: function(response) {
				console.log(response.responseText);
				callback(response.responseText);
			}
		});
	};
	
	var onDeleteTextSelectorItem = function() {
		var t = $(this);
		var ctn = t.closest('.text-selector-item');
		ctn.remove();
	};
	
	var onEditTextSelectorItem = function() {
		var btn = $(this);
		var ctn = btn.closest('.text-selector-item');
		var index = ctn.attr('data-index');
		var gendataId = $('.extraDataData').attr('data-id');
		var text = ctn.find('.text-ctn').html();
		
		textSelectorAdminForm.find('[name=id]').val(gendataId);
		textSelectorAdminForm.find('[name=index]').val(index);
		textSelectorAdminForm.find('[name=isGoodAnswer]').val(ctn.find('input[name=good-answer]').is(':checked'));
		var editorId = $('textarea', textSelectorAdminForm).attr('id');
		tinymce.get(editorId).setContent(text);
	};
	
	var buildTextSelectorItemXml = function(index, isAnswer = false, text) {
		return '<TextSelectorItem index="' + index + '" isAnswer="' + isAnswer + '">' + text + '</TextSelectorItem>'
	};
	
	var buildTextSelectorsXml = function() {
		var items = $('.texts-selector-admin').find('.text-selector-item').not('.template');
		
		var xml = '<TextSelectorItems>';
		items.each(function(i, item) {
			var t = $(item);
			var text = t.find('.text-ctn').html();
			text = text.replace(/&nbsp;/g, ' ');
			xml += buildTextSelectorItemXml(i + 1, t.find('input[type=radio]').is(':checked'), text);
		});
		xml += '</TextSelectorItems>';
		
		return xml;
	};
	
	
	/**
	 * Lexique add word to textarea
	 */
	var onAddLexiqueWordToTextarea = function() {
		var btn = $(this);
		var ctn = btn.closest('.lexique-header');
		var word = $('.lexique-word-select', ctn).val();
		var textarea = btn.closest('.textarea-with-lexique-ctn').find('textarea');
		lexiqueUtils.addLexiqueWordToTextarea(word, textarea);
	};
	
	
	/**
	 * Saving of exercises
	 */
	var saveAdminExercise = function() {
		var btn = $(this);
		$('.exercise-detail-ctn').addClass('processing');
		var gendataId = $('.exercise-detail-ctn').attr('data-id');
		
		var extraDataToSave = null;
		
		if (btn.hasClass('meli-melo')) 				{ extraDataToSave = saveMeliMeloExerciseAdmin(); }	
		else if (btn.hasClass('raconte-moi')) 		{ extraDataToSave = saveRaconteMoiExerciseAdmin(); }
		else if (btn.hasClass('ouvre-les-yeux')) 	{ extraDataToSave = saveOuvreLesYeuxExerciseAdmin(); }
		else if (btn.hasClass('devine'))			{ extraDataToSave = saveDevineExerciseAdmin(); }
		else if (btn.hasClass('le-detective')) 		{ extraDataToSave = saveLeDetectiveExerciseAdmin(); }
		else { console.log("class not recognized: " + btn.attr('class')); }
		
		if (extraDataToSave !== null) {
			saveGenData(gendataId, extraDataToSave, function(response) {
				if (response.indexOf('success') !== -1) {
					location.reload();
				} 
				else {
					$('.exercise-detail-ctn').removeClass('processing');
				}
			});
		} else {
			$('.exercise-detail-ctn').removeClass('processing');
			var firstErrorMsg = $('.admin-error-msg').filter(function() {
				return $(this).css('display') !== "none";
			});
			$('body, html').animate({
				scrollTop: firstErrorMsg.offset().top
			});
		}
	};
	
	var saveMeliMeloExerciseAdmin = function() {
		var container = $('.exercise-detail-ctn.meli-melo');
		if (validateMultiImages(container)) {
			var imagesList = createMultiImagesString($('.exercise-detail-ctn.meli-melo'));
			var imagesXML = buildMultiImagesXml(imagesList, '1');
			return XMLUtils.XMLToString(imagesXML);
		}
		return null;
	};
	
	var saveRaconteMoiExerciseAdmin = function() {
		var container = $('.exercise-detail-ctn.raconte-moi');
		var baseXMLClone = baseExerciseXML.cloneNode(true);
		
		if (validateImageWithTwoTexts(container)) {
			var XMLString = '<Image path="' + $('.exercise-single-image-admin .image', container).attr('src') + '"/>';
			
			var textareaContainers = $('.two-texts-admin-ctn', container).find('.textarea-with-lexique-ctn');
			var text1Textarea = textareaContainers.first().find('textarea');
			var text2Textarea = textareaContainers.last().find('textarea');
			XMLString += '<Text1>' + tinymce.get(text1Textarea.attr('id')).getContent() + '</Text1>';
			XMLString += '<Text2>' + tinymce.get(text2Textarea.attr('id')).getContent() + '</Text2>';

			var stepNode = createStepNode('1', XMLString);
			baseXMLClone.documentElement.appendChild(stepNode.documentElement);
			
			return XMLUtils.XMLToString(baseXMLClone);
		}
		return null;	
	};
	
	var saveOuvreLesYeuxExerciseAdmin = function() {
		var container = $('.exercise-detail-ctn.ouvre-les-yeux');
		var baseXMLClone = baseExerciseXML.cloneNode(true);
		
		if (validateTextarea(container) && validateMultiImages(container)) {
			// Step 1
			var textarea = $('.textarea-with-lexique-ctn', container).find('textarea');
			var textXMLString = '<Text>' + tinymce.get(textarea.attr('id')).getContent() + '</Text>';
			var step1Node = createStepNode('1', textXMLString);
			
			// Step 2
			var imagesList = createMultiImagesString(container);
			var step2Node = createStepNode('2', '<Images list="' + imagesList + '"/>');
			
			baseXMLClone.documentElement.appendChild(step1Node.documentElement);
			baseXMLClone.documentElement.appendChild(step2Node.documentElement);
			
			return XMLUtils.XMLToString(baseXMLClone);
		}
		return null;
	};
	
	var saveDevineExerciseAdmin = function() {
		var container = $('.exercise-detail-ctn.devine');
		var baseXMLClone = baseExerciseXML.cloneNode(true);
		
		if (validateTextarea(container) && validateMultiImages(container)) {
			// Step 1
			var textarea = $('.textarea-with-lexique-ctn', container).find('textarea');
			var textXMLString = '<Text>' + tinymce.get(textarea.attr('id')).getContent() + '</Text>';
			var step1Node = createStepNode('1', textXMLString);
			
			// Step 2
			var imagesList = createMultiImagesString(container);
			var step2Node = createStepNode('2', '<Images list="' + imagesList + '"/>');
			
			baseXMLClone.documentElement.appendChild(step1Node.documentElement);
			baseXMLClone.documentElement.appendChild(step2Node.documentElement);
			
			return XMLUtils.XMLToString(baseXMLClone);
		} 
		return null;
	};
	
	var saveLeDetectiveExerciseAdmin = function() {
		var container = $('.exercise-detail-ctn.le-detective');
		var baseXMLClone = baseExerciseXML.cloneNode(true);
		
		if (validateSingleImage(container) && validateTextSelector(container)) {
			var imageItem = $('.exercise-single-image-admin .image', container);
			var imagePath = imageItem.attr('src');
			var XMLImageString = '<Image path="' + imagePath + '"/>';
			var step1Node = createStepNode('1', XMLImageString);

			var textsXml = buildTextSelectorsXml();
			var step2Node = createStepNode('2', textsXml);
			
			baseXMLClone.documentElement.appendChild(step1Node.documentElement);
			baseXMLClone.documentElement.appendChild(step2Node.documentElement);
			return XMLUtils.XMLToString(baseXMLClone);
		}
		return null;
	};
	
	
	/**
	 * Exercises admin validation
	 */
	var validateTextarea = function(container) {
		var textOk = true;
		var textarea = 	$('.textarea-with-lexique-content textarea', container);
		if (tinymce.get(textarea.attr('id')).getContent().length === 0) {
			$('.textarea-no-text-error', container).slideDown(300);
			textOk = false;
		} else {
			$('.textarea-no-text-error', container).slideUp(300);
		}
		return textOk;
	};
	
	var validateMultiImages = function(container) {
		var imagesItems = $('.multi-images-ctn .multi-images-item-ctn', container);
		var goodAnswerChecked = true;
		if (imagesItems.first().find('.good-answer-selector-ctn').length > 0) {
			goodAnswerChecked = imagesItems.filter(function() {
				return $(this).find('[name=good-answer]').is(':checked');
			}).length > 0;
		}
		var imageFound = false;
		imagesItems.each(function(i, el) {
			var item = $(el);
			if (item.find('img.image').attr('src')) {
				imageFound = true;
			}
		});
		
		if (!imageFound) {
			$('.multi-images-selector-no-image-error', container).slideDown(300);
		} else {
			$('.multi-images-selector-no-image-error', container).slideUp(300);
		}
		
		if (imageFound && !goodAnswerChecked) {
			$('.multi-images-selector-no-answer-error', container).slideDown(300);
		} else {
			$('.multi-images-selector-no-answer-error', container).slideUp(300);
		}
		
		return imageFound && goodAnswerChecked;
	};
	
	var validateSingleImage = function(container) {
		var imageOk = true;
		var imageItem = $('.exercise-single-image-admin .image', container);
		if (!imageItem.attr('src')) {
			$('.single-image-no-image-error', container).slideDown(300);
			imageOk = false;
		} else {
			$('.single-image-no-image-error', container).slideUp(300);
		}
		return imageOk;
	};
	
	var validateTextSelector = function(container) {
		var textSelectorOk = true;
		var textSelectorItems = $('.text-selector-item', container).not('.template');
		var goodAnswerChecked = textSelectorItems.filter(function() {
			return $(this).find('[name=good-answer]').is(':checked');
		}).length > 0;
		
		if (textSelectorItems.length < 2) {
			$('.text-selector-no-texts-error', container).slideDown(300);
			textSelectorOk = false;
		} else {
			$('.text-selector-no-texts-error', container).slideUp(300);
		}
		
		if (!goodAnswerChecked) {
			$('.text-selector-no-answer-error', container).slideDown(300);
			textSelectorOk = false;
		} else {
			$('.text-selector-no-answer-error', container).slideUp(300);
		}
		return textSelectorOk;
	};
	
	var validateImageWithTwoTexts = function(container) {
		var imageOk = true;
		var imageItem = $('.exercise-single-image-admin .image', container);
		if (!imageItem.attr('src')) {
			$('.single-image-no-image-error', container).slideDown(300);
			imageOk = false;
		} else {
			$('.single-image-no-image-error', container).slideUp(300);
		}
		var textsOk = true;
		var textareas = $('.textarea-with-lexique-content textarea', container);
		if (tinymce.get(textareas.first().attr('id')).getContent().length === 0 && tinymce.get(textareas.last().attr('id')).getContent().length === 0) {
			$('.two-texts-no-text-error', container).slideDown(300);
			textsOk = false;
		} else {
			$('.two-texts-no-text-error', container).slideUp(300);
		}
		return imageOk && textsOk;
	};
	
	
	var init = function () {
		XMLUtils = Fw.component.models().XMLUtils;
		lexiqueUtils = Fw.component.models().lexiqueUtils;
		baseExerciseXML = XMLUtils.stringToXML('<ExerciseInfo></ExerciseInfo>');
		
		multiUploadImageAdmin = $('.multi-images-item-ctn .image-ctn');
		removeMultiUploadAdminImageBtn = $('.remove-image-btn', multiUploadImageAdmin);
		tellStoryTextarea = $('.tell-story-textarea');
		singleImageAdminComponent = $('.exercise-single-image-admin');
		textsSelectorAdmin = $('.texts-selector-admin');
		textSelectorItem = $('.text-selector-item');
		textSelectorAdminForm = $('.text-selector-admin-form');
		addLexiqueWordFormCtn = $('.textarea-with-lexique-content .lexique-header');
		adminSaveExerciseInfoBtn = $('.admin-save-exercise-infos');
		
		multiUploadImageAdmin.on('file-picker-change', updateUploadImageAdminVisibility);
		removeMultiUploadAdminImageBtn.on('click', removeMultiUploadAdminImage);
		
		tellStoryTextarea.on('focus', hideTellStoryTextareaOverText);
		tellStoryTextarea.on('blur', showTellStoryTextareaOverTextIfEmpty);
		
		$('.image-ctn .image', singleImageAdminComponent).on('file-picker-change', updateSingleImageAdminVisibility);
		$('.remove-image-btn', singleImageAdminComponent).on('click', removeSingleImageAdminImage);
		
		$('.add-text-btn', textsSelectorAdmin).on('click', onSubmitTextSelectorForm);
		$('.delete-text-btn', textSelectorItem).on('click', onDeleteTextSelectorItem);
		$('.edit-text-btn', textSelectorItem).on('click', onEditTextSelectorItem);
		
		$('.use-lexique-word-btn', addLexiqueWordFormCtn).on('click', onAddLexiqueWordToTextarea);
		
		adminSaveExerciseInfoBtn.on('click', saveAdminExercise);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);


// tinymce.activeEditor.execCommand('mceInsertContent', false, "some text");